import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface CreateAssessmentParams {
  patientId: string;
  encounterId?: string;
  assessmentText?: string;
}

interface CreateAssessmentResponse {
  documentReference: fhirTypes.DocumentReference;
}

export const useCreateAssessment = ({
  encounterId,
  motherEncounterId,
  patientId,
}: {
  encounterId?: string;
  patientId?: string;
  motherEncounterId?: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<CreateAssessmentResponse, CreateAssessmentParams>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.Assessment.CREATE(patientId),
      mutationFn: (params) => {
        return axiosInstance.post("/charting/assessment/", params);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.Assessment.DEFAULT({
            patientId,
            encounterId,
          }),
        });

        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Timeline.ENCOUNTER({
            patientId,
            motherEncounterId,
            encounterId,
          }),
        });
      },
    },
  });
};
